/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateUploadDto } from '../../models/lexplus-update-upload-dto';

export interface UploadsControllerUpdateV1$Params {
  uploadId: string;
  kundeId: number;
  standortId: number;
      body: LexplusUpdateUploadDto
}

export function uploadsControllerUpdateV1(http: HttpClient, rootUrl: string, params: UploadsControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('uploadId', params.uploadId, {});
    rb.query('kundeId', params.kundeId, {});
    rb.query('standortId', params.standortId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

uploadsControllerUpdateV1.PATH = '/v1/uploads/{uploadId}';
